var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIgnoreFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#394694",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2370 5114 c-19 -2 -78 -9 -130 -15 -791 -90 -1522 -586 -1924 -1305 -146 -262 -252 -588 -297 -914 -18 -125 -18 -515 0 -640 105 -762 511 -1409 1146 -1826 776 -510 1793 -550 2615 -104 125 68 154 91 179 143 43 89 15 193 -68 252 -36 25 -52 30 -104 30 -38 0 -73 -6 -92 -16 -168 -91 -236 -124 -330 -162 -323 -130 -670 -180 -1011 -146 -854 84 -1578 664 -1843 1475 -148 452 -148 896 0 1348 214 653 723 1162 1378 1376 449 147 894 147 1345 -1 488 -160 893 -481 1171 -929 162 -262 273 -595 305 -919 45 -460 -70 -940 -326 -1351 -56 -90 -59 -98 -59 -160 0 -78 26 -127 88 -168 56 -37 153 -39 210 -3 60 37 182 235 276 449 469 1060 169 2297 -734 3025 -364 293 -768 469 -1245 542 -100 15 -472 28 -550 19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1612 3639 c-48 -14 -109 -80 -123 -131 -14 -53 -5 -120 21 -162 10 -17 186 -197 389 -401 l371 -370 -384 -385 c-345 -346 -385 -390 -396 -430 -24 -91 8 -178 83 -228 54 -36 154 -39 207 -5 19 12 201 189 405 392 l370 371 385 -384 c346 -345 390 -385 430 -396 159 -42 292 91 250 250 -11 40 -51 84 -396 430 l-384 385 371 370 c203 204 380 386 392 405 34 53 31 153 -5 207 -50 75 -137 107 -228 83 -40 -11 -84 -51 -430 -396 l-385 -384 -370 371 c-204 203 -385 379 -402 390 -38 24 -123 33 -171 18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgnoreFailure);
export default __webpack_public_path__ + "static/media/ignoreFailure.7f0aa8c6.svg";
export { ForwardRef as ReactComponent };